/**
 * Plan Priority Service
 *
 * Reorders a list of floor plans so a given set of "priority" plan ids leads the list, with
 * alphabetical order (by plan name) preserved within each group. Pure data transformation — no
 * HTML/CSS/Redux knowledge, so it isn't tied to any one DOM component. Introduced for the Coming
 * Soon panel (NHS20-8167), which surfaces the selected lot's relevant plans first, but usable by
 * any other panel that needs the same "prioritize, then alphabetical" ordering.
 *
 * @module nativeInteractiveSiteMap/services/planPriorityService
 */

function compareByPlanName(planA, planB) {
  return planA.name.localeCompare(planB.name);
}

/**
 * @param {Object[]} plans - Plans to order, each with at least { planId, name }.
 * @param {Set<number>} priorityPlanIds - Plan ids that should lead the result.
 * @returns {Object[]} New array: priority plans first (alphabetical), then the rest (alphabetical).
 */
export default function prioritizePlans(plans, priorityPlanIds) {
  const priorityPlans = plans.filter((plan) => priorityPlanIds.has(plan.planId)).sort(compareByPlanName);
  const remainingPlans = plans.filter((plan) => !priorityPlanIds.has(plan.planId)).sort(compareByPlanName);
  return [...priorityPlans, ...remainingPlans];
}
